// =============================================================================
// STATS COUNTER ANIMATION
// Counts up numeric portions of stat values when scrolled into view.
// Handles mixed strings like "$80m+", "30", "ASX200", "1,200+".
// Uses IntersectionObserver — fires once per element, no library needed.
// =============================================================================

/**
 * Parse a raw stat string into { prefix, number, suffix } parts.
 * e.g. "$80"    → { prefix: "$", number: 80, suffix: "" }
 *      "30"     → { prefix: "",  number: 30, suffix: "" }
 *      "ASX200" → { prefix: "ASX", number: 200, suffix: "" }
 *      "1,200+" → { prefix: "", number: 1200, suffix: "+" }
 */
function parseStat(raw) {
  // Strip commas so "1,200" → "1200" for parsing
  const stripped = raw.replace(/,/g, '');
  // Match an optional non-numeric prefix, then digits (with optional decimal), then optional suffix
  const match = stripped.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/);
  if (!match) return null;
  return {
    prefix: match[1],
    number: parseFloat(match[2]),
    suffix: match[3],
    // Preserve comma formatting if the original had commas
    hasCommas: /,/.test(raw),
    // Preserve decimal places from original
    decimals: (match[2].includes('.')) ? match[2].split('.')[1].length : 0,
  };
}

function formatNumber(value, parsed) {
  let str;
  if (parsed.decimals > 0) {
    str = value.toFixed(parsed.decimals);
  } else {
    str = Math.round(value).toString();
  }
  if (parsed.hasCommas) {
    str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return parsed.prefix + str + parsed.suffix;
}

function animateCounter(el, parsed, duration = 1500) {
  const start = performance.now();
  const from = 0;
  const to = parsed.number;

  // Ease out quad
  function ease(t) { return t * (2 - t); }

  function tick(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const current = from + (to - from) * ease(progress);
    el.textContent = formatNumber(current, parsed);
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

function initStatsCounters() {
  const stats = document.querySelectorAll('.stat-number[data-stat]');
  if (!stats.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const raw = el.dataset.stat;
      const parsed = parseStat(raw);

      if (parsed) {
        animateCounter(el, parsed);
      }
      // Fire once only
      observer.unobserve(el);
    });
  }, { threshold: 0.3 });

  stats.forEach(el => observer.observe(el));
}

document.addEventListener('DOMContentLoaded', initStatsCounters);
